/**
 * Hạn mức tệp đính kèm — phải khớp ATTACHMENT_POLICY của backend
 * (`vfxanh-admin-api/src/common/constants/attachment.constant.ts`).
 *
 * Giữ là leaf module: KHÔNG gộp vào `constants.js`, KHÔNG thêm import. File đó nằm
 * trong vòng import nên named export của nó là `undefined` với module nạp sớm.
 */
export const FILE_UPLOAD_LIMITS = {
  /** Chỉ PDF được nới lên 30MB; ảnh và tài liệu giữ ngưỡng cũ. */
  MAX_FILE_SIZE_PDF: 30 * 1024 * 1024,
  /** Ảnh còn được nén tiếp nên đây chỉ là chặn thô đầu vào. */
  MAX_FILE_SIZE_IMAGE: 20 * 1024 * 1024,
  /** DOC, DOCX, XLS, XLSX — giữ nguyên trần cũ. */
  MAX_FILE_SIZE_DOCUMENT: 5 * 1024 * 1024,
  MAX_TOTAL_SIZE: 30 * 1024 * 1024,
  MAX_PENDING_FILES: 10,
  /** Tính cả tệp đã đính kèm từ những lượt trước. */
  MAX_ATTACHMENTS: 10,
  /** Có `doc` và `xls` vì Office đời cũ và WPS vẫn xuất mặc định ra chúng. */
  ALLOWED_EXTENSIONS: [
    'jpg',
    'jpeg',
    'png',
    'webp',
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
  ],
  ACCEPT_ATTR: '.jpg,.jpeg,.png,.webp,.pdf,.doc,.docx,.xls,.xlsx',
  ALLOWED_LABEL:
    'ảnh (JPG, PNG, WEBP), PDF, Word (DOC, DOCX) và Excel (XLS, XLSX)',
};
